// project imports
import Utils from "./utils"
import * as keys from "./keys"

import AuthStore from "modules/login/store/AuthStore";
import FamilyMemberTypeEnum from 'modules/family-details-form/FamilymemberTypeEnum'
import { toJS } from "mobx";
import moment from "moment"

const FormObserver = (formRef, props) => {

  let biRequest = props.data.bi_request;
  let liAge = Number(biRequest.LI_ENTRY_AGE)
  let PT_value = biRequest.PT_VALUE

  formRef.$('premium-term').observe({
    key: 'value',
    call: ({ field, form }) => {
      let annuityOption = form.$("annuity-option")?.value?.id

      let defermentPeiodList = Utils.defermentPeiodOptionList(field.value.id, annuityOption)

      formRef.$("deferment-period").set("value", { label: "10", id: "9" })
      formRef.$("deferment-period").set("extra", {
        ...formRef.$("deferment-period").extra,
        options: defermentPeiodList,
      });

      let requestData = {
        ppt: field.value.id,
        defermentPeiod: form.$("deferment-period")?.value?.id
      }

      Utils.updateBi(keys.PR_PPT, requestData, props.data.package_id, formRef, props)
    }
  })

  formRef.$("payment-frequency").observe({
    key: "value",
    call: ({ field }) => {
      let premium = formRef.$("premium-amt").value
      let frequency = field.value.id
      let data = {
        premium: premium,
        frequency: frequency,
      }
      Utils.updateBi(
        keys.FREQUENCY,
        data,
        props.data.package_id,
        formRef,
        props
      )
    },
  })

  formRef.$("source-of-purchase-price").observe({
    key: "value",
    call: ({ field }) => {

      const sppValue = Number(field.value.id)

      if (sppValue === 4) {
        // pran-number
        formRef.$("pran-number").set("extra", {
          ...formRef.$("pran-number").extra,
          visible: true,
        });
      } else {
        formRef.$("pran-number").set("value", "")
        formRef.$("pran-number").set("extra", {
          ...formRef.$("pran-number").extra,
          visible: false,
        });
      }
      let requestData = {
        sourceOfPP: sppValue,
        pranNo: sppValue === 4 ? formRef.$("pran-number").value : ""
      }
      Utils.updateBi(
        keys.SOURCE_OF_PURCHASE_PRICE,
        requestData,
        props.data.package_id,
        formRef,
        props
      );
    },
  })

  formRef.$("annuity-benefit").observe({
    key: "value",
    call: ({ field, form }) => {

      let defermentPeriodValue = form.$("deferment-period").value.id;
      let annuityBenefitValue = field.value.id

      Utils.updateBi(
        keys.ANNUITY_BENEFIT,
        { defermentPeriodValue, annuityBenefitValue },
        props.data.package_id,
        formRef,
        props
      );
    },
  })

  formRef.$("life-status").observe({
    key: "value",
    call: ({ field, form }) => {

      let annuityOptionList = []
      let pptValue = form.$("premium-term")?.value?.id
      let defermentPeiodList = Utils.defermentPeiodOptionList(pptValue, field.value.id)

      formRef.$("deferment-period").set("value", { label: "10", id: "10" })
      formRef.$("deferment-period").set("extra", {
        ...formRef.$("deferment-period").extra,
        options: defermentPeiodList,
      });
      let defermentPeiod = form.$("deferment-period")?.value?.id
      Utils.updateBi(keys.DEFERMENT_PERIOD, defermentPeiod, props.data.package_id, formRef, props);



      if (field.value.id === '3') {

        // ! // ! disabling Name of the Secondary Annuitant, DOB of the Secondary Annuitant, Gender of the Secondary Annuitant

        form.$("secondary-annuitant-name").set("disabled", true)
        form.$("secondary-annuitant-date-of-birth").set("disabled", true);
        form.$("secondary-annuitant-gender").set("disabled", true);

        //! for setting the values of the default
        form.$('secondary-annuitant-name').set('value', '');
        form.$("secondary-annuitant-date-of-birth").set("value", "");
        form.$("secondary-annuitant-gender").set("value", "");

        if (Number(liAge) <= 70) {
          annuityOptionList = [
            { label: "Deferred Annuity (Single Life)", id: "1" },
            {
              label:
                "Deferred Annuity with Return of Purchase Price on Death (Single life)",
              id: "2",
            },
          ]
        } else {
          annuityOptionList = [
            {
              label:
                "Deferred Annuity with Return of Purchase Price on Death (Single life)",
              id: "2",
            },
          ]
        }
      } else {
        form.$("secondary-annuitant-name").set("disabled", false)
        form.$("secondary-annuitant-date-of-birth").set("disabled", false);
        form.$("secondary-annuitant-gender").set("disabled", false);

        let requestData = props.data.bi_request
        let familyMemberType = props.data.family_member_type
        let journeyData = toJS(AuthStore.journeyData);

        let secondary_annuitant_name = requestData.SecondaryAnnuitantName?.toString() || '';
        let secondary_annuitant_date_of_birth = requestData.SecondaryAnnuitantDateofbirth || '';
        let secondary_annuitant_gender = requestData.SecondaryAnnuitantGender?.toString() || ''

        let genderList = { "Male": '8', "Female": '9' }

        switch (familyMemberType) {

          case 'SELF':
            let spouseDetail = journeyData.family_details_list.find(item => item.family_member_type === FamilyMemberTypeEnum.SPOUSE)

            if (spouseDetail) {
              secondary_annuitant_name = spouseDetail.middle_name ? `${spouseDetail.first_name} ${spouseDetail.middle_name} ${spouseDetail.last_name}` : `${spouseDetail.first_name} ${spouseDetail.last_name}`

              secondary_annuitant_date_of_birth = spouseDetail.dob

              secondary_annuitant_gender = genderList[spouseDetail.gender]
            }

            break;

          case 'SPOUSE':
            let selfDetail = journeyData.family_details_list.find(item => item.family_member_type === FamilyMemberTypeEnum.SELF)

            if (selfDetail) {
              secondary_annuitant_name = selfDetail.middle_name ? `${selfDetail.first_name} ${selfDetail.middle_name} ${selfDetail.last_name}` : `${selfDetail.first_name} ${selfDetail.last_name}`

              secondary_annuitant_date_of_birth = selfDetail.dob

              secondary_annuitant_gender = genderList[selfDetail.gender]
            }

            break;

          case 'GRAND_FATHER':
            let grandMotherDetail = journeyData.family_details_list.find(item => item.family_member_type === FamilyMemberTypeEnum.GRAND_MOTHER)

            if (grandMotherDetail) {
              secondary_annuitant_name = grandMotherDetail.middle_name ? `${grandMotherDetail.first_name} ${grandMotherDetail.middle_name} ${grandMotherDetail.last_name}` : `${grandMotherDetail.first_name} ${grandMotherDetail.last_name}`

              secondary_annuitant_date_of_birth = grandMotherDetail.dob

              secondary_annuitant_gender = genderList[grandMotherDetail.gender]
            }

            break;

          case 'GRAND_MOTHER':
            let grandFatherDetail = journeyData.family_details_list.find(item => item.family_member_type === FamilyMemberTypeEnum.GRAND_MOTHER)

            if (grandFatherDetail) {
              secondary_annuitant_name = grandFatherDetail.middle_name ? `${grandFatherDetail.first_name} ${grandFatherDetail.middle_name} ${grandFatherDetail.last_name}` : `${grandFatherDetail.first_name} ${grandFatherDetail.last_name}`

              secondary_annuitant_date_of_birth = grandFatherDetail.dob

              secondary_annuitant_gender = genderList[grandFatherDetail.gender]
            }

            break;

          default:
            break;
        }

        // ! secondary-annuitant-name
        formRef.$('secondary-annuitant-name').set('value', secondary_annuitant_name)

        // ! secondary-annuitant-date-of-birth
        formRef.$('secondary-annuitant-date-of-birth').set('value', secondary_annuitant_date_of_birth)
        console.log('dobValue', moment(secondary_annuitant_date_of_birth).format('LL'));

        // ! secondary-annuitant-gender
        switch (secondary_annuitant_gender) {
          case '8':
            formRef.$('secondary-annuitant-gender').set('value', { label: "Male", id: '13' })
            break;
          case '9':
            formRef.$('secondary-annuitant-gender').set('value', { label: "Female", id: '14' })
            break;
          //  case '7':
          //   formRef.$('secondary-annuitant-gender').set('value', {label:"Transgender",id:'7'})
          //   break;    
          default:
            break;
        }

        Utils.updateBi(keys.NAME_OF_THE_SECONDARY_ANNUITANT, secondary_annuitant_name, props.data.package_id, formRef, props);

        Utils.updateBi(keys.GENDER_NAME_OF_THE_SECONDARY_ANNUITANT, secondary_annuitant_gender, props.data.package_id, formRef, props);

        const dateString = secondary_annuitant_date_of_birth ? moment(secondary_annuitant_date_of_birth).format('LL') : ""

        Utils.updateBi(keys.DOB_NAME_OF_THE_SECONDARY_ANNUITANT, dateString, props.data.package_id, formRef, props)

        annuityOptionList = [
          // {
          //   label:
          //     "Deferred Annuity with Return of Purchase Price on Death (Joint Life, Last Survivor)",
          //   id: "3",
          // }
        ]
      }
      formRef.$("annuity-option").set("extra", {
        ...formRef.$("annuity-option").extra,
        options: [...annuityOptionList],
      });

      formRef.$("annuity-option").set("value", annuityOptionList[0])
      let requestData = {
        annuityOption: annuityOptionList[0].id,
        lifeStatus: field.value.id
      }

      Utils.updateBi(
        keys.LIFE_STATUS,
        requestData,
        props.data.package_id,
        formRef,
        props
      );
    },
  })

  formRef.$("annuity-mode").observe({
    key: "value",
    call: ({ field }) => {
      Utils.updateBi(
        keys.ANNUITY_MODE,
        field.value.id,
        props.data.package_id,
        formRef,
        props
      );
    },
  })

  formRef.$("deferment-period").observe({
    key: "value",
    call: ({ field ,form}) => {
      form.$('accrual-of-survival-benefit').set('value', { label: 'No', id: "25" })
      Utils.updateBi(
        keys.DEFERMENT_PERIOD,
        field.value.id,
        props.data.package_id,
        formRef,
        props
      );
    },
  })

  formRef.$("annuity-option").observe({
    key: "value",
    call: ({ field }) => {
      Utils.updateBi(
        keys.ANNUITY_OPTION,
        field.value.id,
        props.data.package_id,
        formRef,
        props
      );
    },
  })

  formRef.$("secondary-annuitant-gender").observe({
    key: "value",
    call: ({ field }) => {
      Utils.updateBi(
        keys.GENDER_NAME_OF_THE_SECONDARY_ANNUITANT,
        field.value.id,
        props.data.package_id,
        formRef,
        props
      );
    },
  })

  // !Accrual Of Survival Benefits
  formRef.$('accrual-of-survival-benefit').observe({
    key: 'value',
    call: ({ field, form }) => {
      Utils.handleAsbCondition(formRef, field.value.id)
      let asbStartYear1 = ""
      let asbEndYear1 = ""
      let asb2 = ""
      let asbStartYear2 = ""
      let asbEndYear2 = ""
      let asb3 = ""
      let asbStartYear3 = ""
      let asbEndYear3 = ""


      if (field.value.id === 24) {

        let defermentPeriodValue = form.$("deferment-period").value.label;
        Utils.handleASBstartPolicyOneConditions(formRef, props.data.product_name, PT_value, Number(defermentPeriodValue))

        if (formRef.$('asb-start-age-(1st-opt-in)').value) {
          asbStartYear1 = formRef.$('asb-start-age-(1st-opt-in)').value.id
        }
        if (formRef.$('asb-end-age-(1st-opt-in)').value) {
          asbEndYear1 = formRef.$('asb-end-age-(1st-opt-in)').value.id
        }
        asb2 = formRef.$('accrual-of-survival-benefits-year-2').value.id
        if (formRef.$('asb-start-age-(2nd-opt-in)').value) {
          asbStartYear2 = formRef.$('asb-start-age-(2nd-opt-in)').value.id
        }
        if (formRef.$('asb-end-age-(2nd-opt-in)').value) {
          asbEndYear2 = formRef.$('asb-end-age-(2nd-opt-in)').value.id
        }
        asb3 = formRef.$('accrual-of-survival-benefits-year-3').value.id
        if (formRef.$('asb-start-age-(3rd-opt-in)').value) {
          asbStartYear3 = formRef.$('asb-start-age-(3rd-opt-in)').value.id
        }
        if (formRef.$('asb-end-age-(3rd-opt-in)').value) {
          asbEndYear3 = formRef.$('asb-end-age-(3rd-opt-in)').value.id
        }

      }
      let requestData = {
        asb1: field.value.id,
        asbStartYear1,
        asbEndYear1,
        asb2,
        asbStartYear2,
        asbEndYear2,
        asb3,
        asbStartYear3,
        asbEndYear3,
      }
      Utils.updateBi(keys.ACCRUALOFSURVIVALBENEFIT_1, requestData, props.data.package_id, formRef, props)
    }
  })

  formRef.$('asb-start-age-(1st-opt-in)').observe({
    key: 'value',
    call: ({ field }) => {
      let asb2 = ""
      let asbStartYear2 = ""
      let asbEndYear2 = ""
      let asb3 = ""
      let asbStartYear3 = ""
      let asbEndYear3 = ""

      Utils.handleASBFirstStartEndCondition(formRef, formRef.$('accrual-of-survival-benefit').value.id)
      let asbEndYearOneList = Utils.fetchASBendPolicyOne(field.value.id, formRef.$("asb-start-age-(1st-opt-in)").extra.optionList, formRef.$("asb-end-age-(1st-opt-in)").extra.preDefinedOptList)
      formRef.$("asb-end-age-(1st-opt-in)").set("extra", {
        ...formRef.$("asb-end-age-(1st-opt-in)").extra,
        optionList: asbEndYearOneList,
      });
      let selectedAsbEndYearOne = asbEndYearOneList.some((item) => item.id === formRef.$("asb-end-age-(1st-opt-in)").value?.id);
      if (!selectedAsbEndYearOne) {
        let optData = asbEndYearOneList.find((item) => item.label === field.value.label)
        formRef
          .$("asb-end-age-(1st-opt-in)")
          .set("value", optData);
      }
      if (Number(field.value.label) === Number(99) || Number(formRef.$("asb-end-age-(1st-opt-in)").value.label) === Number(99)) {
        formRef.$('accrual-of-survival-benefits-year-2').set("disabled", true)
      } else {
        formRef.$('accrual-of-survival-benefits-year-2').set("disabled", false)
      }
      asb2 = formRef.$('accrual-of-survival-benefits-year-2').value.id
      if (formRef.$('asb-start-age-(2nd-opt-in)').value) {
        asbStartYear2 = formRef.$('asb-start-age-(2nd-opt-in)').value.id
      }
      if (formRef.$('asb-end-age-(2nd-opt-in)').value) {
        asbEndYear2 = formRef.$('asb-end-age-(2nd-opt-in)').value.id
      }
      asb3 = formRef.$('accrual-of-survival-benefits-year-3').value.id
      if (formRef.$('asb-start-age-(3rd-opt-in)').value) {
        asbStartYear3 = formRef.$('asb-start-age-(3rd-opt-in)').value.id
      }
      if (formRef.$('asb-end-age-(3rd-opt-in)').value) {
        asbEndYear3 = formRef.$('asb-end-age-(3rd-opt-in)').value.id
      }

      let requestData = {
        asbStart1: field.value.id,
        asbEnd1: formRef.$("asb-end-age-(1st-opt-in)").value.id,
        asb2,
        asbStartYear2,
        asbEndYear2,
        asb3,
        asbStartYear3,
        asbEndYear3,
      }
      Utils.updateBi(keys.ASB_STARTPOLICYYEAR_1, requestData, props.data.package_id, formRef, props)
    }
  })


  formRef.$('asb-end-age-(1st-opt-in)').observe({
    key: 'value',
    call: ({ field }) => {
      let asb2 = ""
      let asbStartYear2 = ""
      let asbEndYear2 = ""
      let asb3 = ""
      let asbStartYear3 = ""
      let asbEndYear3 = ""
      Utils.handleASBFirstStartEndCondition(formRef, formRef.$('accrual-of-survival-benefit').value.id)
      asb2 = formRef.$('accrual-of-survival-benefits-year-2').value.id
      if (Number(field.value.label) >= Number(99) || Number(formRef.$("asb-start-age-(1st-opt-in)").value.label) === Number(99)) {
        formRef.$('accrual-of-survival-benefits-year-2').set("disabled", true)
      } else {
        formRef.$('accrual-of-survival-benefits-year-2').set("disabled", false)
      }
      if (formRef.$('asb-start-age-(2nd-opt-in)').value) {
        asbStartYear2 = formRef.$('asb-start-age-(2nd-opt-in)').value.id
      }
      if (formRef.$('asb-end-age-(2nd-opt-in)').value) {
        asbEndYear2 = formRef.$('asb-end-age-(2nd-opt-in)').value.id
      }
      asb3 = formRef.$('accrual-of-survival-benefits-year-3').value.id
      if (formRef.$('asb-start-age-(3rd-opt-in)').value) {
        asbStartYear3 = formRef.$('asb-start-age-(3rd-opt-in)').value.id
      }
      if (formRef.$('asb-end-age-(3rd-opt-in)').value) {
        asbEndYear3 = formRef.$('asb-end-age-(3rd-opt-in)').value.id
      }
      let requestData = {
        asbEnd1: field.value.id || "",
        asb2,
        asbStartYear2,
        asbEndYear2,
        asb3,
        asbStartYear3,
        asbEndYear3,
      }
      Utils.updateBi(keys.ASB_ENDPOLICYYEAR_1, requestData, props.data.package_id, formRef, props)
    }
  })

  formRef.$('withdrawal-parcentage-1').observe({
    key: 'value',
    call: ({ field }) => {

      Utils.updateBi(keys.ASB_WITHDRAWALPERCENTAGE_1, field.value.id, props.data.package_id, formRef, props)

    }
  })
  formRef.$('accrual-of-survival-benefits-year-2').observe({
    key: 'value',
    call: ({ field }) => {
      Utils.handleAsbTwoCondition(formRef, field.value.id)
      let asbStartYear2 = ""
      let asbEndYear2 = ""
      let asb3 = ""
      let asbStartYear3 = ""
      let asbEndYear3 = ""
      if (field.value.id === 329) {
        Utils.handleASBTwostartPolicyOneConditions(formRef)
        if (formRef.$('asb-start-age-(2nd-opt-in)').value) {
          asbStartYear2 = formRef.$('asb-start-age-(2nd-opt-in)').value.id
        }
        if (formRef.$('asb-end-age-(2nd-opt-in)').value) {
          asbEndYear2 = formRef.$('asb-end-age-(2nd-opt-in)').value.id
        }
        asb3 = formRef.$('accrual-of-survival-benefits-year-3').value.id
        if (formRef.$('asb-start-age-(3rd-opt-in)').value) {
          asbStartYear3 = formRef.$('asb-start-age-(3rd-opt-in)').value.id
        }
        if (formRef.$('asb-end-age-(3rd-opt-in)').value) {
          asbEndYear3 = formRef.$('asb-end-age-(3rd-opt-in)').value.id
        }

      }
      let requestData = {
        asb2: field.value.id,
        asbStartYear2,
        asbEndYear2,
        asb3,
        asbStartYear3,
        asbEndYear3,
      }
      Utils.updateBi(keys.ACCRUALOFSURVIVALBENEFIT_2, requestData, props.data.package_id, formRef, props)
    }
  })

  formRef.$('asb-start-age-(2nd-opt-in)').observe({
    key: 'value',
    call: ({ field }) => {
      let asb3 = ""
      let asbStartYear3 = ""
      let asbEndYear3 = ""
      Utils.handleASBTwoStartEndCondition(formRef, formRef.$('accrual-of-survival-benefits-year-2').value.id)
      let asbTwoEndYearOneList = Utils.fetchASBendPolicyOne(field.value.id, formRef.$("asb-start-age-(2nd-opt-in)").extra.optionList, formRef.$("asb-end-age-(2nd-opt-in)").extra.preDefinedOptList);
      formRef.$("asb-end-age-(2nd-opt-in)").set("extra", {
        ...formRef.$("asb-end-age-(2nd-opt-in)").extra,
        optionList: asbTwoEndYearOneList,
      });
      let selectedAsbTwoEndYearOne = asbTwoEndYearOneList.some((item) => item.id === formRef.$("asb-end-age-(2nd-opt-in)").value?.id);
      if (!selectedAsbTwoEndYearOne) {
        let optData = asbTwoEndYearOneList.find((item) => item.label === field.value.label)
        formRef
          .$("asb-end-age-(2nd-opt-in)")
          .set("value", optData);
      }
      if (Number(field.value.label) === Number(99) || Number(formRef.$("asb-end-age-(2nd-opt-in)").value.label) === Number(99)) {
        formRef.$('accrual-of-survival-benefits-year-3').set("disabled", true)
      } else {
        formRef.$('accrual-of-survival-benefits-year-3').set("disabled", false)
      }
      asb3 = formRef.$('accrual-of-survival-benefits-year-3').value.id
      if (formRef.$('asb-start-age-(3rd-opt-in)').value) {
        asbStartYear3 = formRef.$('asb-start-age-(3rd-opt-in)').value.id
      }
      if (formRef.$('asb-end-age-(3rd-opt-in)').value) {
        asbEndYear3 = formRef.$('asb-end-age-(3rd-opt-in)').value.id
      }

      let requestData = {
        asbStartYear2: field.value.id,
        asbEndYear2: formRef.$("asb-end-age-(2nd-opt-in)").value.id,
        asb3,
        asbStartYear3,
        asbEndYear3,
        asbEndYear3,

      }
      Utils.updateBi(keys.ASB_STARTPOLICYYEAR_2, requestData, props.data.package_id, formRef, props)
    }
  })

  formRef.$('asb-end-age-(2nd-opt-in)').observe({
    key: 'value',
    call: ({ field }) => {
      let asb3 = ""
      let asbStartYear3 = ""
      let asbEndYear3 = ""
      Utils.handleASBTwoStartEndCondition(formRef, formRef.$('accrual-of-survival-benefits-year-2').value.id)
      asb3 = formRef.$('accrual-of-survival-benefits-year-3').value.id
      if (Number(field.value.label) >= Number(99) || Number(formRef.$("asb-start-age-(2nd-opt-in)").value.label) === Number(99)) {
        formRef.$('accrual-of-survival-benefits-year-3').set("disabled", true)
      } else {
        formRef.$('accrual-of-survival-benefits-year-3').set("disabled", false)
      }
      if (formRef.$('asb-start-age-(3rd-opt-in)').value) {
        asbStartYear3 = formRef.$('asb-start-age-(3rd-opt-in)').value.id
      }
      if (formRef.$('asb-end-age-(3rd-opt-in)').value) {
        asbEndYear3 = formRef.$('asb-end-age-(3rd-opt-in)').value.id
      }

      let requestData = {
        asbEndYear2: field.value.id || "",
        asb3,
        asbStartYear3,
        asbEndYear3,
      }
      Utils.updateBi(keys.ASB_ENDPOLICYYEAR_2, requestData, props.data.package_id, formRef, props)
    }
  })

  formRef.$('withdrawal-parcentage-2').observe({
    key: 'value',
    call: ({ field }) => {

      Utils.updateBi(keys.ASB_WITHDRAWALPERCENTAGE_2, field.value.id, props.data.package_id, formRef, props)

    }
  })

  formRef.$('accrual-of-survival-benefits-year-3').observe({
    key: 'value',
    call: ({ field }) => {
      Utils.handleAsbThreeCondition(formRef, field.value.id)
      let asbStartYear3 = ""
      let asbEndYear3 = ""

      if (field.value.id === 634) {
        Utils.handleASBThreestartPolicyOneConditions(formRef)
        if (formRef.$('asb-start-age-(3rd-opt-in)').value) {
          asbStartYear3 = formRef.$('asb-start-age-(3rd-opt-in)').value.id
        }
        if (formRef.$('asb-end-age-(3rd-opt-in)').value) {
          asbEndYear3 = formRef.$('asb-end-age-(3rd-opt-in)').value.id
        }

      }
      let requestData = {
        asb3: field.value.id,
        asbStartYear3,
        asbEndYear3,
      }
      Utils.updateBi(keys.ACCRUALOFSURVIVALBENEFIT_3, requestData, props.data.package_id, formRef, props)
    }
  })

  formRef.$('asb-start-age-(3rd-opt-in)').observe({
    key: 'value',
    call: ({ field }) => {
      let asbThreeEndYearOneList = Utils.fetchASBendPolicyOne(field.value.id, formRef.$("asb-start-age-(3rd-opt-in)").extra.optionList, formRef.$("asb-end-age-(3rd-opt-in)").extra.preDefinedOptList);
      formRef.$("asb-end-age-(3rd-opt-in)").set("extra", {
        ...formRef.$("asb-end-age-(3rd-opt-in)").extra,
        optionList: asbThreeEndYearOneList,
      });
      let selectedAsbThreeEndYearOne = asbThreeEndYearOneList.some((item) => item.id === formRef.$("asb-end-age-(3rd-opt-in)").value?.id);
      if (!selectedAsbThreeEndYearOne) {
        let optData = asbThreeEndYearOneList.find((item) => item.label === field.value.label)
        formRef
          .$("asb-end-age-(3rd-opt-in)")
          .set("value", optData);
      }

      let requestData = {
        asbStartYear3: field.value.id || "",
        asbEndYear3: formRef.$("asb-end-age-(3rd-opt-in)").value.id,

      }
      Utils.updateBi(keys.ASB_STARTPOLICYYEAR_3, requestData, props.data.package_id, formRef, props)
    }
  })

  formRef.$('asb-end-age-(3rd-opt-in)').observe({
    key: 'value',
    call: ({ field }) => {
      let requestData = {
        asbEndYear3: field.value.id || "",
      }
      Utils.updateBi(keys.ASB_ENDPOLICYYEAR_3, requestData, props.data.package_id, formRef, props)
    }
  })

  formRef.$('withdrawal-parcentage-3').observe({
    key: 'value',
    call: ({ field }) => {

      Utils.updateBi(keys.ASB_WITHDRAWALPERCENTAGE_3, field.value.id, props.data.package_id, formRef, props)

    }
  })

}

export default FormObserver
